import React, { useEffect, useState } from "react";
import { Button, Typography, Card, CardContent, Chip, Divider, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, } from "@mui/material";
import instance from "../../Utils/api";
import { useParams } from "react-router-dom";
import OrderItems from "../../User/components/Order_Items";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentIcon from '@mui/icons-material/Payment';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import "../../Admin/styles/admin.scss";
import "../styles/components/Order_details.scss";
import ReviewDialog from "../../Admin/components/ReviewDialog";
import { Download } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";


const OrderDetails = () => {
    const navigate = useNavigate();
    const { orderId } = useParams();
    const [paymentsData, setPaymentsData] = useState([]);
    const [orderData, setOrderData] = useState();
    const [openDialog, setOpenDialog] = useState(false);
    const [reviewData, setReviewData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [openPaymentPopup, setOpenPaymentPopup] = useState(false);
    const [selectedOfflinePayment, setSelectedOfflinePayment] = useState(null);


    const handleSubmitReview = async ({ rating, description }) => {
        try {
            const payload = {
                order_id: orderData?._id,
                rating: rating?.toString(),
                comment: description,
            };
            const response = await instance.post("/Review/Review", payload);

            if (response.status === 201) {
                toast.success(response.data.message);
                fetchOrderById();
                fetchReviewById();
            } else {
                toast.error("Failed to submit review");
            }
        } catch (error) {
            console.error("Error submitting review:", error);
            toast.error("Add Comments");
        }
    };

    const fetchReviewById = async () => {
        try {
            const response = await instance.get(`/Review/order/${orderId}`);
            setReviewData(response?.data?.review);
        } catch (error) {
            console.log("error", error);
        }
    };

    const fetchPaymentOrderById = async () => {
        try {
            const response = await instance.get(
                `/Payment/getPaymentByOrderId?OrderId=${orderId}`
            );
            setPaymentsData(response?.data?.data);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchOrderById = async () => {
        try {
            const response = await instance.get(
                `/Order/OrderById?order_id=${orderId}`
            );
            setOrderData(response?.data?.data);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchPaymentOrderById();
        fetchOrderById();
        fetchReviewById();
    }, []);

    const downloadInvoice = async (id) => {
        try {
            setLoading(true);
            const response = await instance.post('/Order/downloadInvoice', { orderId: id }, {
                responseType: 'arraybuffer',
                headers: {
                    'Accept': 'application/pdf',
                    'Content-Type': 'application/json'
                }
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'invoice.pdf';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.log("error", error);
        } finally {
            setLoading(false);
        }
    }


    const handleOpenPopup = (payment) => {
        setSelectedOfflinePayment(payment);
        setOpenPaymentPopup(true);
    };


    const offlinePayment = async (paymentsData) => {
        try {
            const response = await instance.patch(`/order/ApprovePayment/${paymentsData._id}`);
            if (response.status === 200) {
                toast.success(response.status.message || "Payment Approved Successfully!");
                setOpenPaymentPopup(false);
                fetchPaymentOrderById();
                fetchOrderById();
                fetchReviewById();
            }
        } catch (error) {
            console.log("error", error);
            toast.error("Failed to approve payment");
        }
    };


    return (
        <React.Fragment>
            <div className="order-details-container">
                {/* Header Section */}
                <div className="order-header">

                    <div className="header-left">

                        <div className="header-info">
                            <Typography variant="h4" className="page-title">
                                Order Details
                            </Typography>
                            <Typography variant="body2" className="order-subtitle">
                                #{orderData?.order_id || "Loading..."}
                            </Typography>
                        </div>

                        <Button
                            className="back-button"
                            onClick={() => navigate(-1)}
                            startIcon={<KeyboardBackspaceIcon />}
                        >
                            Back
                        </Button>
                    </div>

                    <div className="header-actions" style={{ marginTop: "30px" }}>

                        {paymentsData
                            ?.filter((p) => p.paymentMode === "Online" && p.status === "Pending")
                            .map((payment, index) => (
                                <Button
                                    key={index}
                                    className="pay-button"
                                    variant="contained"
                                    startIcon={<PaymentIcon />}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        window.open(payment.payment_link, "_blank");
                                    }}
                                >
                                    Pay ₹{payment.amount}
                                </Button>
                            ))}

                        {paymentsData
                            ?.filter(
                                (p) =>
                                    ["UPI/QR", "Card", "Cash"].includes(p.paymentMode) &&
                                    p.status === "Pending"
                            )
                            .map((payment, index) => (
                                <Button
                                    key={index}
                                    className="pay-button"
                                    variant="contained"
                                    startIcon={<PaymentIcon />}
                                    onClick={() => handleOpenPopup(payment)}
                                >
                                    Approve ₹{payment.amount}
                                </Button>
                            ))}

                    </div>
                </div>

                <div className="content-wrapper">

                    {/* Order Summary Card */}
                    <Card className="summary-card">
                        <CardContent className="summary-content">
                            <div className="summary-header">
                                <ShoppingBagIcon className="summary-icon" />
                                <Typography variant="h5" className="summary-title">
                                    Order Summary
                                </Typography>
                            </div>

                            <div className="summary-grid">
                                <div className="summary-item">
                                    <Typography className="summary-label">Order ID</Typography>
                                    <Typography className="summary-value">
                                        {orderData?.order_id || "----"}
                                    </Typography>
                                </div>

                                <div className="summary-item">
                                    <Typography className="summary-label">Status</Typography>
                                    <Chip
                                        label={orderData?.status === "New Order received" ? "Order Placed" : orderData?.status}
                                        className="status-chip"
                                        variant="outlined"
                                    />
                                </div>

                                <div className="summary-item">
                                    <Typography className="summary-label">Ordered Date</Typography>
                                    <Typography className="summary-value">
                                        {orderData?.createdAt
                                            ? new Date(orderData.createdAt).toLocaleDateString("en-GB")
                                            : "---"}
                                    </Typography>
                                </div>

                                {orderData?.status === "Order Delivered" && (
                                    <div className="summary-item">
                                        <Typography className="summary-label">Delivery Date</Typography>
                                        <Typography className="summary-value">
                                            {orderData?.updatedAt
                                                ? new Date(orderData.updatedAt).toLocaleDateString("en-GB")
                                                : "---"}
                                        </Typography>
                                    </div>
                                )}


                            </div>
                        </CardContent>
                    </Card>

                    {/* Invoice Card */}
                    <Card className="invoice-card">
                        <CardContent className="invoice-content">
                            <div className="invoice-header-section">
                                <div className="invoice-title-wrapper">
                                    <div className="invoice_div">
                                        <ReceiptIcon className="invoice-icon" />
                                        <div>
                                            <Typography variant="h5" className="invoice-main-title">
                                                Payment Invoice
                                            </Typography>
                                            <Typography variant="body2" className="invoice-subtitle">
                                                Invoice #{orderData?.order_id || "INV-001"}
                                            </Typography>
                                        </div>
                                    </div>
                                    <div className="order-items-header">
                                        {orderData?.status === "Order Delivered" && (
                                            <>

                                                <Button
                                                    className="review-button"
                                                    variant="outlined"
                                                    disabled={loading}
                                                    onClick={() => downloadInvoice(orderData?._id)}
                                                >
                                                    <Download sx={{ width: "19px", marginRight: "5px" }} />
                                                    Download Invoice
                                                </Button>
                                            </>
                                        )}
                                    </div>
                                </div>

                            </div>

                            <Divider className="section-divider" />

                            {/* Amount Breakdown */}
                            <div className="breakdown-section">
                                <Typography variant="h6" className="breakdown-title">
                                    Amount Breakdown
                                </Typography>

                                <div className="breakdown-items">
                                    <div className="breakdown-row">
                                        <span className="breakdown-label">Actual Amount</span>
                                        <span className="breakdown-value">

                                            ₹{Number(
                                                (Number(orderData?.Actual_price) || 0) -
                                                (Number(orderData?.gst_price) || 0)
                                            ).toFixed(2)}

                                        </span>
                                    </div>

                                    <div className="breakdown-row discount-row">
                                        <span className="breakdown-label">
                                            Discount ({orderData?.discount || 0}%)
                                        </span>
                                        <span className="breakdown-value discount-value">
                                            -₹{Number(orderData?.Discount_price || 0).toFixed(2)}
                                        </span>
                                    </div>

                                    <div className="breakdown-row discount-row">
                                        <span className="breakdown-label">
                                            GST (5%)
                                        </span>
                                        <span className="breakdown-value discount-value">
                                            +₹{Number(orderData?.gst_price || 0).toFixed(2)}
                                        </span>
                                    </div>

                                    <div className="breakdown-row subtotal-row">
                                        <span className="breakdown-label">Subtotal</span>
                                        <span className="breakdown-value">₹{Number(orderData?.total_amount || 0).toFixed(2)}</span>
                                    </div>

                                    <div className="breakdown-row total-row">
                                        <span className="breakdown-label">Total Amount</span>
                                        <span className="breakdown-value total-value">
                                            ₹{Number(orderData?.total_amount || 0).toFixed(2)}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <Divider className="section-divider" />

                            {/* Payment Status */}
                            <div className="payment-status-section">
                                <Typography variant="h6" className="payment-status-title">
                                    Payment Status
                                </Typography>

                                <div className="payment-status-grid">
                                    <div className="payment-status-card paid-card">
                                        <div className="status-indicator paid-indicator"></div>
                                        <div className="status-content">
                                            <Typography className="status-label">Amount Paid</Typography>
                                            <Typography className="status-amount">
                                                ₹{Number(orderData?.paid_amount || 0).toFixed(2)}
                                            </Typography>
                                        </div>
                                    </div>

                                    <div className="payment-status-card raised-card">
                                        <div className="status-indicator raised-indicator"></div>
                                        <div className="status-content">
                                            <Typography className="status-label">Raised Amount</Typography>
                                            <Typography className="status-amount">
                                                ₹{Number(orderData?.payment_amount || 0).toFixed(2)}
                                            </Typography>
                                        </div>
                                    </div>

                                    <div className="payment-status-card pending-card">
                                        <div className="status-indicator pending-indicator"></div>
                                        <div className="status-content">
                                            <Typography className="status-label">Remaining Amount</Typography>
                                            <Typography className="status-amount">
                                            ₹{Number(orderData?.pending_amount || 0).toFixed(2)}
                                            </Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Divider className="section-divider" />

                            {/* Total Due */}
                            <div className="total-due-section">
                                <div className="total-due-wrapper">
                                    <Typography className="due-label">Total Due:</Typography>
                                    <Typography className="due-amount">
                                     ₹{Number(orderData?.pending_amount || 0).toFixed(2)}
                                    </Typography>
                                </div>
                            </div>
                        </CardContent>
                    </Card>

                    {/* Transaction Details Card */}
                    <Card className="transaction-card">
                        <CardContent className="transaction-content">
                            <div className="transaction-header">
                                <PaymentIcon className="transaction-icon" />
                                <Typography variant="h5" className="transaction-title">
                                    Transaction History
                                </Typography>
                            </div>
                            <div className="transaction-table">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Transaction ID</th>
                                            <th>Amount</th>
                                            <th>Status</th>
                                            <th>Payment Mode</th>
                                            <th>Created Date</th>
                                        </tr>
                                    </thead>

                                    <tbody >
                                        {paymentsData.map((data, index) => (
                                            <tr key={index} >
                                                <td>
                                                    {data?.merchant_Transaction_Id || "---"}
                                                </td>
                                                <td>
                                                    ₹{data?.amount || "---"}
                                                </td>
                                                <td>
                                                    <Chip
                                                        label={data?.status || "---"}
                                                        size="small"
                                                        sx={{
                                                            bgcolor:
                                                                data?.status?.toLowerCase() === "done" ? "#E1FCEF" :
                                                                    data?.status?.toLowerCase() === "pending" ? "#FCF2E6" :
                                                                        data?.status?.toLowerCase() === "failed" ? "#FFEDEF" : "#eee",

                                                            color:
                                                                data?.status?.toLowerCase() === "done" ? "#14804A" :
                                                                    data?.status?.toLowerCase() === "pending" ? "#AA5B00" :
                                                                        data?.status?.toLowerCase() === "failed" ? "#D1293D" : "#000",

                                                            fontWeight: 500
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    {data?.paymentMode || "---"}
                                                </td>
                                                <td>
                                                    {data?.createdAt
                                                        ? new Date(data.createdAt).toLocaleDateString("en-GB")
                                                        : "---"}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </CardContent>
                    </Card>

                    {/* Address Details Card */}
                    <Card className="address-card">
                        <CardContent className="address-content">
                            <div className="address-header">
                                <LocationOnIcon className="address-icon" />
                                <Typography variant="h5" className="address-title">
                                    Delivery Address
                                </Typography>
                            </div>

                            <div className="address-details">
                                <div className="address-row">
                                    <Typography className="address-label">Name</Typography>
                                    <Typography className="address-value">
                                        {orderData?.address?.name || "---"}
                                    </Typography>
                                </div>

                                <div className="address-row">
                                    <Typography className="address-label">Mobile Number</Typography>
                                    <Typography className="address-value">
                                        {orderData?.address?.mobile || "---"}
                                    </Typography>
                                </div>

                                <div className="address-row full-width">
                                    <Typography className="address-label">Address</Typography>
                                    <Typography className="address-value address-full">
                                        {orderData?.address ?
                                            `${orderData.address.landmark}, ${orderData.address.line_1}, ${orderData.address.line_2}, ${orderData.address.city}, ${orderData.address.state} - ${orderData.address.pincode}`
                                            : "---"
                                        }
                                    </Typography>
                                </div>
                            </div>
                        </CardContent>
                    </Card>

                    {/* Order Items Section */}
                    <Card className="order-items-card">
                        <CardContent className="order-items-content">
                            <div className="order-items-header">
                                <div className="items-title-wrapper">
                                    <ShoppingBagIcon className="items-icon" />
                                    <Typography variant="h5" className="items-title">
                                        Order Items
                                    </Typography>
                                </div>

                                {orderData?.status === "Order Delivered" && (
                                    <Button
                                        className="review-button"
                                        variant="outlined"
                                        onClick={() => setOpenDialog(true)}
                                    >
                                        {orderData?.review_given === true ? "View Review" : "Add Review"}
                                    </Button>
                                )}
                            </div>

                            <div className="order-items-grid">
                                {orderData?.sub_orders?.map((suborder) => (
                                    <OrderItems
                                        key={suborder._id}
                                        suborder={suborder}
                                        fetchOrderById={fetchOrderById}
                                        paymentsData={paymentsData}
                                    />
                                ))}
                            </div>
                        </CardContent>
                    </Card>
                </div>

                <ReviewDialog
                    openDialog={openDialog}
                    handleClose={() => setOpenDialog(false)}
                    handleSubmitReview={handleSubmitReview}
                    reviewData={reviewData}
                    isViewMode={orderData?.review_given}
                />
            </div>

            <Dialog
                open={openPaymentPopup}
                onClose={() => setOpenPaymentPopup(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Approve Offline Payment

                    {/* Close Icon */}
                    <IconButton onClick={() => setOpenPaymentPopup(false)}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedOfflinePayment && (
                        <>
                            <Typography
                                sx={{
                                    mb: 2,
                                    fontWeight: 600,
                                    color: "#333",
                                    borderLeft: "4px solid #3f51b5",
                                    paddingLeft: "8px",
                                }}
                            >
                                <strong>Payment Mode:</strong> {selectedOfflinePayment.paymentMode}
                            </Typography>

                            <Typography sx={{
                                mb: 2,
                                fontWeight: 500,
                                color: "#333",
                                borderLeft: "4px solid #3f51b5",
                                paddingLeft: "8px",
                            }}><strong>Amount:</strong> ₹{selectedOfflinePayment.amount}</Typography>
                            <Typography sx={{
                                mb: 2,
                                fontWeight: 500,
                                color: "#333",
                                borderLeft: "4px solid #3f51b5",
                                paddingLeft: "8px",
                            }}><strong>Transaction ID:</strong> {selectedOfflinePayment.merchant_Transaction_Id}</Typography>
                            <Typography sx={{
                                mb: 2,
                                fontWeight: 500,
                                color: "#333",
                                borderLeft: "4px solid #3f51b5",
                                paddingLeft: "8px",
                            }}><strong>Status:</strong> {selectedOfflinePayment.status}</Typography>
                            <Typography sx={{
                                mb: 2,
                                fontWeight: 500,
                                color: "#333",
                                borderLeft: "4px solid #3f51b5",
                                paddingLeft: "8px",
                            }}><strong>Date:</strong> {new Date(selectedOfflinePayment.createdAt).toLocaleString()}</Typography>
                        </>
                    )}
                </DialogContent>

                <DialogActions>

                    <Button
                        sx={{
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "14px",
                            fontWeight: 500,
                            lineHeight: "21px",
                            color: "#ffffff",
                            textTransform: "capitalize",
                            backgroundColor: "#e37b00",
                            padding: "8px 21px",
                        }}
                        variant="contained"
                        onClick={() => offlinePayment(selectedOfflinePayment)}
                    >
                        Approve Payment
                    </Button>
                </DialogActions>
            </Dialog>


        </React.Fragment>
    );
};

export default OrderDetails;
